export default __webpack_public_path__ + "static/media/plus-icon.dd8effbe.svg";